import DataTableCard from "../../components/common/DataTableCard";
import PageHero from "../../components/common/PageHero";
export default function Ledger() {
  return (
    <div className="erp-page-grid">
      <PageHero title="Ledger" subtitle="Party-wise transaction history" />

      <DataTableCard
        title="Ledger Entries"
        columns={[
          { key: "date", label: "Date" },
          { key: "particular", label: "Particular" },
          { key: "debit", label: "Debit" },
          { key: "credit", label: "Credit" },
          { key: "balance", label: "Balance" },
        ]}
        rows={[
          {
            date: "22-04-2026",
            particular: "Sale",
            debit: "₹0",
            credit: "₹20,000",
            balance: "₹20,000",
          },
        ]}
      />
    </div>
  );
}